import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import Page from "src/components/Page";
import "jspdf-autotable";
import useSettings from "src/hooks/useSettings";
import Iconify from "src/components/Iconify";

import WithoutPagination from "src/components/mrt-table/WithoutPagination";

import AddPurchaseOrder from "./add";
import { useQuery } from "react-query";
import { getAllDraftPurchaseByStatus, masterGetData } from "src/pages/api";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { PATH_DASHBOARD } from "src/routes/paths";
import OrderDetail from "../draft-order/order-detail";

export default function PurchaseOrder() {
  const { themeStretch } = useSettings();
  // const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);

  const columns = [
    {
      accessorKey: "schoolName",
      header: "School Name",
    },
    {
      accessorKey: "purchaseOrderID",
      header: "Purchase OrderID",
    },
    {
      accessorKey: "price",
      header: "Total Items",
      size: 100,
      Cell: ({ row }) => row?.original.orderDetails?.length ?? 0,
    },
  ];

  const { data: purchaseOrderList } = useQuery({
    queryKey: ["draftOrder", 2],
    queryFn: getAllDraftPurchaseByStatus,
    // enabled: !!selectedSchool,
  });
  // const { data } = useQuery({
  //   queryKey: ["getData", "schools", 0, 100],
  //   queryFn: masterGetData,
  // });

  // useEffect(() => {
  //   setSelectedSchool(data ? data?.data[0]?.id : "");
  // }, [data]);

  return (
    <>
      {open && (
        <AddPurchaseOrder
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
          }}
          row={selectedRow}
        />
      )}

      <Page title="General:Darft Order">
        <Container maxWidth={themeStretch ? false : "xl"} id={"report"}>
          <HeaderBreadcrumbs
            heading={`Purchase Order`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Inventory",
              },
              { name: "Purchase Order" },
            ]}
          />
          {/* <Grid container spacing={3}>
            <Grid item xs={3}>
              <TextField
                label="School"
                size="small"
                select
                SelectProps={{ native: true }}
                fullWidth
                // sx={{ maxWidth: "250px", width: "100%" }}
                value={selectedSchool}
                InputLabelProps={{ shrink: true }}
                onChange={e => {
                  setSelectedSchool(e.target.value);
                }}
              >
                <option value={""}>Choose a School</option>
                {data?.data?.map((el, index) => (
                  <option value={el.id} key={index}>
                    {el.schoolName}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid> */}
          <Box mt={4}>
            <WithoutPagination
              data={purchaseOrderList?.data || []}
              columns={columns}
              loading={false}
              renderRowActions={({ row, table }) => {
                const filterPendingItems = row?.original?.orderDetails?.filter(
                  el => el.receivedQuantity !== el.quantity
                );
                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={filterPendingItems.length === 0}
                      onClick={() => {
                        setOpen(true);
                        setSelectedRow(row.original);
                      }}
                    >
                      Order Entry
                    </Button>
                  </Box>
                );
              }}
              // renderTopToolbarCustomActions={({ table }) => (
              //   <Box
              //     sx={{
              //       display: "flex",
              //       gap: "16px",
              //       padding: "8px",
              //       flexWrap: "wrap",
              //     }}
              //   >
              //     <Button
              //       variant="contained"
              //       color="secondary"
              //       onClick={() => {
              //         setOpen(true);
              //       }}
              //     >
              //       Add New
              //     </Button>
              //   </Box>
              // )}
              renderDetailPanel={({ row }) => (
                <OrderDetail row={row.original} isPurchaseOrder />
              )}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  size: "100",
                },
              }}
            />
          </Box>
        </Container>
      </Page>
    </>
  );
}
